// client/src/routes/_auth/invite.$token.tsx — SCR-AUTH-006 „Invitație" · D-1590.
//
// 04 §8.1 spells this route `/invite/$token`, and the server now builds the same link
// (`InvitationIssuer.AcceptRoute`); it used to build `/invitatii/`, which nothing answered.
//
// Nobody is redirected AWAY from here, in either direction: an anonymous visitor is the ordinary
// case — the person was invited precisely because they are not inside yet — and a signed-in one
// is the other ordinary case, so the screen itself decides what to do with the token it holds.
//
// It still has to BOOTSTRAP, which is a different thing and is what every other route does in
// `beforeLoad`. Opening a pasted link is a hard navigation, so nothing has presented the refresh
// cookie yet and the store is still `unknown` — and `unknown` is the branch that renders
// „Se verifică invitația…". Without this the page waits on a bootstrap nobody started, forever.
// `ensureSession()` redirects nobody; it resolves the store to `anonymous` or `authenticated`
// once, and every guard in the app awaits the same promise.

import { createFileRoute } from '@tanstack/react-router';

import { AcceptInvitation } from '@/features/auth/AcceptInvitation';
import { ensureSession } from '@/session';

export const Route = createFileRoute('/_auth/invite/$token')({
  beforeLoad: async () => {
    await ensureSession();
  },
  component: AcceptInvitationScreen,
});

function AcceptInvitationScreen() {
  const { token } = Route.useParams();
  return <AcceptInvitation token={token} />;
}
